import { roles } from '@nxsys/store/constants';
import { hasTenantFeed } from '@nxsys/store/slices/app/roleOf';

// The event a session's own notifications arrive on. NX-5877: only an admin
// listens on the tenant's channel, and a role not listed here listens on none.
// Any other role used to listen on the tenant's channel.
export const notificationChannelOf = (user: any): string | undefined => {
  if (hasTenantFeed(user?.role)) {
    return `new-notification-${user?.companyParentId}`;
  }
  switch (user?.role) {
    case roles.employee:
      return `new-notification-${user?.subcontractorId?.id}`;
    case roles.employer:
      return `new-notification-${user?.id}`;
    // NX-5237: the BE emits an agency's notifications on the AGENCY id, so
    // without this an agency user got no live push at all — the bell only
    // caught up on the next page load.
    case roles.agency:
      return `new-notification-${user?.agencyId?.id}`;
    default:
      return undefined;
  }
};
